// Modal.js
import React from "react";
import ReactDOM from "react-dom";
import Icon from "./icons";
import GradientBGContainer from "./gradientBgContainer";

interface SiteModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: React.ReactNode;
  children: React.ReactNode;
  closeOnBackdrop?: boolean;
  width?: boolean; // Optional width prop (e.g., '600px', '50%')
  modalWidth?: number ; // Optional width prop (e.g., '600px', '50%')
  className?: string;
  allowOverflow?: boolean; // Allow content to overflow modal boundaries
  isBlur?: boolean; // Blur the background when true
}

const SiteModal = ({
    isOpen,
    onClose,
    title,
    children,
    closeOnBackdrop = true,
    width = false,
    modalWidth = 800,
    className = ``,
    allowOverflow = false,
    isBlur = false,
}: SiteModalProps) => {
    if (!isOpen) return null;

  const handleBackdropClick = (e: any) => {
    if (e.target === e.currentTarget && closeOnBackdrop) {
      onClose();
    }
  };

    return ReactDOM.createPortal(
        <div
            className={`fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-[120] ${isBlur ? 'backdrop-blur-sm' : ''}`}
            onClick={handleBackdropClick}
        >
            <div
                className={`rounded-lg shadow-md ${allowOverflow ? "overflow-visible" : "overflow-hidden"} ${
                    width ? `${modalWidth == 800 ? "w-1/2" : `min-w-[80vw] max-w-[80vw]`}` : "w-[600px]"
                } ${className}`}
            >
                {/* Header */}
                <GradientBGContainer className="flex items-center justify-between">
                    <h2 className="text-white text-lg font-semibold">{title}</h2>
                    <Icon name="close" size={30} className="text-white" onClick={onClose} />
                </GradientBGContainer>

        {/* Body */}
        <div className="bg-white">{children}</div>
      </div>
    </div>,
    document.body
  );
};

export default SiteModal;
